
export const LONG_TAP:number = 30;
export const TAP:number = 10;
export const SUCCESS:number[] = [30, 10, 20];
export const ERROR:number[] = [30, 40, 30];

export function hapticFeedback(pattern?:number|number[]) {
	if (!('vibrate' in navigator)) return;
	navigator.vibrate(pattern || 20);
}
